"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Box = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var spacings = {
    xs: '2px',
    small: '4px',
    medium: '8px',
    'medium-large': '12px',
    large: '16px',
    xl: '24px',
    '2xl': '32px',
    '3xl': '40px',
    '4xl': '48px',
    '5xl': '64px',
    '6xl': '80px'
};
var Box = function (_a) {
    var align = _a.align, area = _a.area, border = _a.border, children = _a.children, className = _a.className, _b = _a.component, Component = _b === void 0 ? 'div' : _b, _c = _a.direction, direction = _c === void 0 ? 'column' : _c, expand = _a.expand, gap = _a.gap, justify = _a.justify, padding = _a.padding, paddingBottom = _a.paddingBottom, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingTop = _a.paddingTop, wrap = _a.wrap, restProps = __rest(_a, ["align", "area", "border", "children", "className", "component", "direction", "expand", "gap", "justify", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "wrap"]);
    return (react_1["default"].createElement(Component, __assign({}, restProps, { className: (0, css_1.cx)('vs-box', (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: ", ";\n        ", "\n        ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n      "], ["\n        display: flex;\n        flex-direction: ", ";\n        ", "\n        ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n          ", "\n      "])), direction, area && "grid-area: ".concat(area, ";"), gap && "gap: ".concat(spacings[gap], ";"), border &&
            'border: 1px solid var(--color-border-form-default); border-radius: 2px;', padding && "padding: ".concat(spacings[padding], ";"), paddingBottom && "padding-bottom: ".concat(spacings[paddingBottom], ";"), paddingLeft && "padding-left: ".concat(spacings[paddingLeft], ";"), paddingRight && "padding-right: ".concat(spacings[paddingRight], ";"), paddingTop && "padding-top: ".concat(spacings[paddingTop], ";"), align &&
            "align-items: ".concat(align === 'start'
                ? 'flex-start'
                : align === 'end'
                    ? 'flex-end'
                    : align, ";"), justify &&
            "justify-content: ".concat(justify === 'start'
                ? 'flex-start'
                : justify === 'end'
                    ? 'flex-end'
                    : justify, ";"), expand && 'flex: 1;', wrap && 'flex-wrap: wrap;'), className) }), children));
};
exports.Box = Box;
var templateObject_1;
